import Can from "../../utils/can";
import Notifications from "../systemsettings/notifications";

const NotificationsPage = () => {
  return (
    <div className="row">
      <Can permission={"view_admin_notification"}>
        <Notifications />
      </Can>
    </div>
  );
};

export default NotificationsPage;
